export const defaultOptions = {
    selectors: {
        allTabs: `[role="tab"]`,
        allPanels: `[role="tabpanel]`,
        panelButtons: `.generic-btn`
    },
    classes: {
        hide: `is-hidden`,
        ghostButton: `ghost-btn`,
    },
    tabIdFormat: `tab-?`,
    panelIdFormat: `tabpanel-?`,
}

export function initialize(_options = defaultOptions) {
    console.log("Initializing panel switcher.");

    const options = _options;

    const activateTab = tabIndex => {
        const allTabs = document.querySelectorAll(options.selectors.allTabs);
        const allPanels = document.querySelectorAll(options.selectors.allPanels);

        // Disattiva tutte le tab
        allTabs.forEach(tab => {
            tab.setAttribute('aria-selected', 'false');
            tab.setAttribute('tabindex', '-1');
        });

        // Nascondi tutti i panel
        allPanels.forEach(panel => {
            panel.classList.add(options.classes.hide);
        });
        // Attiva la tab corrente
        const tabId = options.tabIdFormat.replace('?', tabIndex);
        const currentTab = document.getElementById(tabId);

        const panelId = options.panelIdFormat.replace('?', tabIndex);
        const currentPanel = document.getElementById(panelId);

        if (currentTab && currentPanel) {
            currentTab.setAttribute('aria-selected', 'true');
            currentTab.removeAttribute('tabindex');
            currentPanel.classList.remove(options.classes.hide);
        }
    }

    document.addEventListener(`DOMContentLoaded`, () => {
        const allPanels = document.querySelectorAll(options.selectors.allPanels);
        allPanels.forEach((panel, index) => {
            const tabIndex = index + 1;
            const buttons = panel.querySelectorAll(options.selectors.panelButtons);
            buttons.forEach(button => {
                button.addEventListener('click', () => {
                    if (button.classList.contains(options.classes.ghostButton)) {
                        // Bottone "indietro" - vai alla tab precedente
                        if (tabIndex > 1) {
                            activateTab(tabIndex - 1);
                        }
                    } else {
                        // Bottone "Continua" - vai alla tab successiva
                        const totalTabs = allPanels.length;
                        if (tabIndex < totalTabs) {
                            activateTab(tabIndex + 1);
                        }
                    }
                });
            });
        });
        // Gestisci anche il click diretto sulle tab
        const allTabs = document.querySelectorAll(options.selectors.allTabs);
        allTabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                activateTab(index + 1);
            });
        });
    });

    console.log("Panel switcher initialized");
}